import "../fonts/fonts.scss";
import { initAnchorScroll } from "./anchorScroll";
import { initExampleLanguageSwitcher } from "./exampleLanguageSwitcher";
import { initSyntaxHighlighting } from "./highlight";
import { initMobileNav } from "./mobileNav";
import { initSearch } from "./search";
import { initThemeToggle } from "./theme";

initThemeToggle();
initExampleLanguageSwitcher();
initSearch();
initMobileNav();
initAnchorScroll();
void initSyntaxHighlighting();
